import { DatePicker, Form, type FormItemProps } from 'antd';
import i18n from 'i18next';
import type moment from 'moment';
import type { BasePickerProps } from 'rc-picker';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import type { SharedTimeProps } from 'rc-picker/lib/interface';
import type { FC } from 'react';
import { isRequiredField } from '../../../utilz';

const MyDatePicker = DatePicker.generatePicker(momentGenerateConfig);

interface FormTimePickerProps
  extends Pick<FormItemProps, 'rules' | 'colon' | 'name'>,
    Pick<BasePickerProps, 'placeholder' | 'disabled'>,
    Pick<SharedTimeProps, 'use12Hours'> {
  label?: string;
  editMode?: boolean;
  forFilter?: boolean;
  margin?: string;
  singleLineMode?: boolean;
  inverMode?: boolean;
  disableValidation?: boolean;
  hideOkButton?: boolean;
  minuteStep?: SharedTimeProps['minuteStep'];
  onChange?: (value: moment.Moment | null, dateString: string | string[]) => void;
}

const FormTimePicker: FC<FormTimePickerProps> = ({
  placeholder = i18n.t('translation:default.fields.selectTime'),
  label,
  editMode = false,
  forFilter = false,
  margin = 'mb-15',
  singleLineMode = false,
  name = `testFiled-${Math.random()}`,
  rules = [],
  colon = false,
  inverMode = false,
  disabled,
  disableValidation = false,
  hideOkButton = true,
  use12Hours = true,
  minuteStep = 1,
  onChange,
}) => {
  return (
    <>
      <Form.Item
        className={`form-time-selector-container ${inverMode ? 'invert-mode' : ''} ${margin} ${
          singleLineMode ? 'single-line-mode' : ''
        } form-input-container ${!editMode ? 'edit-mode-off' : ''}`}
        name={name}
        rules={disableValidation ? [] : rules}
        {...(label
          ? {
              label: (
                <span>
                  {label}
                  {rules.length > 0 && isRequiredField(rules) && !disableValidation && (
                    <span className="required">*</span>
                  )}
                </span>
              ),
            }
          : {})}
        colon={colon}
      >
        <MyDatePicker
          picker="time"
          id={name}
          format={`${use12Hours ? 'hh:mm A' : 'HH:mm'}`}
          use12Hours={use12Hours}
          needConfirm={false}
          placeholder={editMode ? placeholder : ''}
          hideDisabledOptions={false}
          className={`${forFilter ? 'filter-input' : 'form-input'} `}
          disabled={disabled}
          popupClassName={`time-picker-popup-container ${hideOkButton ? 'hide-ok-button' : ''}`}
          showTime={{ minuteStep: minuteStep }}
          {...(onChange ? { onChange } : {})}
        />
      </Form.Item>
    </>
  );
};

export default FormTimePicker;
